<template>
  <div class="listen-test-management">
    <section>
      <el-page-header @back="goBack" content="新学员录入"></el-page-header>

      <div class="enteringStudent">
        <el-form ref="form" label-width="120px" class="form-style" :model="form" size="mini" :rules="rules">
          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="学员姓名" required prop="realname">
                  <el-input v-model="form.realname" style="width: 300px" placeholder="请输入学员姓名"></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="12">
              <div>
                <el-form-item label="学员账号" required prop="name">
                  <el-input v-model="form.name" style="width: 300px" placeholder="请设置学员账号"></el-input>

                  <el-tooltip class="item" effect="dark" content="学员账号为6-20位字母或数字组成,不能包含特殊字符,推荐以学员家长手机号作为平台账号" placement="top">
                    <i style="margin-left: 10px" class="el-icon-question"></i>
                  </el-tooltip>
                  <span style="padding-left:10px;font-size:12px;color:#666">默认密码：{{$store.state.globalCheck.defaultPassword}}</span>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="学员性别" required>
                  <el-radio-group v-model="form.sex">
                    <el-radio label="男"></el-radio>
                    <el-radio label="女"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="出生日期">
                  <el-date-picker type="date" placeholder="请选择出生日期" v-model="form.birthday" style="width: 300px" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="所在学校">
                  <el-input v-model="form.school_name" style="width: 300px" placeholder="请输入所在学校"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="在校年级">
                  <el-select v-model="form.grade" placeholder="请选择在校年级" style="width: 300px">
                    <el-option label="幼儿园小班" :value="1"></el-option>
                    <el-option label="幼儿园中班" :value="2"></el-option>
                    <el-option label="幼儿园大班" :value="3"></el-option>
                    <el-option label="一年级" :value="4"></el-option>
                    <el-option label="二年级" :value="5"></el-option>
                    <el-option label="三年级" :value="6"></el-option>
                    <el-option label="四年级" :value="7"></el-option>
                    <el-option label="五年级" :value="8"></el-option>
                    <el-option label="六年级" :value="9"></el-option>
                    <el-option label="初一" :value="10"></el-option>
                    <el-option label="初二" :value="11"></el-option>
                    <el-option label="初三" :value="12"></el-option>
                    <el-option label="高一" :value="13"></el-option>
                    <el-option label="高二" :value="14"></el-option>
                    <el-option label="高三" :value="15"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="联系电话" required prop="parent_a_phone_num">
                  <el-select v-model="form.parent_a" style="width: 100px">
                    <el-option label="父亲" value="父亲"></el-option>
                    <el-option label="母亲" value="母亲"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                  <el-input v-model="form.parent_a_phone_num" placeholder="请输入手机号" style="width: 180px; margin-left: 20px"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-form-item label="家长微信" prop="parent_b_phone_num">
                  <el-select v-model="form.parent_b" style="width: 100px">
                    <el-option label="父亲" value="父亲"></el-option>
                    <el-option label="母亲" value="母亲"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                  <el-input v-model="form.parent_b_phone_num" placeholder="请输入手机号" style="width: 180px; margin-left: 20px"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="主负责人" prop="leader">
                  <el-select v-model="form.leader" placeholder="请选择主负责人" style="width: 300px">
                    <el-option v-for="item in user_list" :key="item.id" :label="item.realname + '(' + item.name + ')'" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <el-row>
        <el-col :span="24">
          <div style="margin-top: 20px; text-align: center">
            <el-button size="small" type="primary" @click="addOrUpdateNormalStudent">录 入</el-button>
          </div>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
import {
  addOrUpdateNormalStudent,
  getCampusUserList,
} from '@/api/educational.js'

export default {
  name: 'addnewstudent',

  data() {
    var validatePhone = (rule, value, callback) => {
      if (value && !/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    var validate_username = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账号'))
      }
      if (!/^[a-zA-Z0-9]{6,20}$/.test(value)) {
        callback(new Error('账号必须为6-20位字母或数字组成'))
      } else {
        callback()
      }

      if (!this.checkSpecialKey(value)) {
        callback(new Error('不能含有特殊字符！！'))
      } else {
        callback()
      }
    }

    return {
      rules: {
        realname: [
          {
            type: 'string',
            required: true,
            message: '请输入学员真实姓名',
            trigger: 'change',
          },
          { max: 20, message: '名称长度不能超过20个字符' },
          {
            type: 'string',
            required: true,
            message: '请输入学员真实姓名',
            trigger: 'blur',
          },
        ],

        name: [
          { validator: validate_username, trigger: 'blur' },
          {
            required: true,
            message: '请输入账号',
            trigger: 'change',
          },
        ],

        leader: [
          { required: true, message: '请选择负责人', trigger: 'change' },
        ],

        parent_a_phone_num: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validatePhone, trigger: 'blur' },
        ],
        parent_b_phone_num: [{ validator: validatePhone, trigger: 'change' }],
      },

      form: {
        name: '',
        realname: '', //
        sex: '男', //
        grade: [], //
        parent_a: '', //
        parent_a_phone_num: '',
        nickname: '',
        school_name: '',
        birthday: '',
        parent_b: '',
        parent_b_phone_num: '',
        leader: '',
        remark: '',
        educational_institution_campus_id: '',
      },

      user_list: [],
    }
  },
  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue, oldValue) {
        console.log('校区监听')
        console.log(newValue)
        console.log(oldValue)
        if (newValue.length == 0) {
          this.$message.warning('目标校区不能为空')
        } else if (newValue.length > 1) {
          this.$message.warning('只能选择1个目标校区')
          this.user_list = []
          this.form.leader = ''
        } else {
          this.getCampusUserList()
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (
      this.$store.state.user.selected_schools.length == 0 ||
      this.$store.state.user.selected_schools.length > 1
    ) {
      this.$message.warning('请选择1个目标校区')
    } else {
      this.getCampusUserList()
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: 'student-management',
      })
    },

    checkSpecialKey(str) {
      let specialKey =
        "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
      for (let i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false
        }
      }
      return true
    },

    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
        this.form.leader
      })
    },

    //新学员报名
    addOrUpdateNormalStudent() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.$store.state.user.selected_schools.length == 1) {
            console.log('选择了1个校区')
          } else {
            console.log('目标校区有问题')
            this.$message.warning('请选择1个目标校区')
            return
          }

          console.log('选择的校区')
          console.log(this.$store.state.user.selected_schools)

          addOrUpdateNormalStudent({
            name: this.form.name,
            realname: this.form.realname,
            sex: this.form.sex,
            grade: this.form.grade,
            parent_a: this.form.parent_a,
            parent_a_phone_num: this.form.parent_a_phone_num,
            nickname: this.form.nickname,
            school_name: this.form.school_name,
            birthday: this.form.birthday,
            parent_b: this.form.parent_b,
            parent_b_phone_num: this.form.parent_b_phone_num,
            leader: this.form.leader,
            remark: this.form.remark,
            educational_institution_campus_id: this.$store.state.user
              .selected_schools[0],
          }).then((res) => {
            console.log('新学员报名')
            console.log(res)
            if (res.is_create) {
              this.$message.success('报名成功')
              this.$router.push({ name: 'student-management' })
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.listen-test-management {
  background-color: #fff;
  margin: 15px;
  border-radius: 5px;
  section {
    padding: 15px;

    .form-style {
      margin-top: 30px;
    }

    .table-style {
      margin-top: 0px;
    }
  }
  .form-style-open {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>
